import { EPermissoes } from '@/enums/ePermissoes';

export default [
  {
    description: 'Relatorio Analitico',
    path: 'relatorio-analitico',
    name: 'recebimentoitemanaliticocabos',
    component: () => import('@/views/dashboard/recebimento-item/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.Relatorio],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Recebimento Consolidado',
    path: 'recebimento-consolidado',
    name: 'recebimentoconsolidadocabos',
    component: () => import('@/views/dashboard/recebimento/Index.vue'),
    meta: { utlTipoFornecimentoId: 206, permissions: [EPermissoes.Relatorio], escopoObra: 'obra' },
    goesToMenu: true
  },
  {
    description: 'Ensaio Consolidado',
    path: 'ensaio-consolidado',
    name: 'ensaioconsolidadoanaliticocabos',
    component: () => import('@/views/dashboard/ensaio-consolidado/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 206,
      permissions: [EPermissoes.Relatorio],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
];



